// Copyright (c) 2017 Deere & Company

import Dealer, {getDefaultState as getDealerDefaultState} from './dealer';
import KeyValuePair, {getDefaultState as getKeyValuePairDefaultState} from './key-value-pair';
import SpecialAllowancePartialDebit, {getDefaultState as getSpecialAllowancePartialDebitDefaultState} from './special-allowance-partial-debit';
import PartialDebit from './partial-debit';
import t from 'tcomb';

const Debit = t.struct({
    claimNumber: t.String,
    claimType: KeyValuePair,
    debitType: KeyValuePair,
    isDebitFormRequired: t.Bool,
    netAmountPaid: t.maybe(t.Number),
    partialDebit: t.list(PartialDebit),
    pin: t.String,
    reasonForDebit: t.String,
    responsibleAccount: Dealer,
    specialAllowancePartialDebit: SpecialAllowancePartialDebit,
    specialAllowanceType: KeyValuePair,
    subClaimType: KeyValuePair
}, {
    name: 'Debit',
    strict: true
});

export const getDefaultState = () => new Debit({
    claimNumber: '',
    claimType: getKeyValuePairDefaultState(),
    debitType: getKeyValuePairDefaultState(),
    isDebitFormRequired: false,
    netAmountPaid: null,
    partialDebit: [],
    pin: '',
    reasonForDebit: '',
    responsibleAccount: getDealerDefaultState(),
    specialAllowancePartialDebit: getSpecialAllowancePartialDebitDefaultState(),
    specialAllowanceType: getKeyValuePairDefaultState(),
    subClaimType: getKeyValuePairDefaultState()
});

Debit.prototype.getParts = function getParts() {

    const parts = this.partialDebit.filter(item => item.itemType === 'MAT');

    return parts;

};

Debit.prototype.getLabors = function getLabors() {

    const labors = this.partialDebit.filter(item => item.itemType === 'FR');

    return labors;

};

Debit.prototype.getOtherCredits = function getOtherCredits() {

    const credits = this.partialDebit.filter(item => item.itemType === 'SUBL');

    return credits;

};

Debit.prototype.getAdjustedItems = function getAdjustedItems() {

    const adjustedItems = this.partialDebit.filter(item => item.adjustmentType.key !== '01');

    return adjustedItems;

};

export default Debit;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/debit.js